const constituencies = [
    { value: '0', name: 'None' },
    { value: '1', name: 'Alfred Ndzo DM' },
    { value: '2', name: 'Alice' },
    { value: '3', name: 'Alicedale' },
    { value: '4', name: 'Aliwal North' },
    { value: '5', name: 'Amahlathi' },
    { value: '6', name: 'Amathole' },
    { value: '7', name: 'Amathole DM' },
    { value: '8', name: 'Barkley East' },
    { value: '9', name: 'Blue Crane' },
    { value: '10', name: 'Blue Crane LM' },
    { value: '11', name: 'Buffalo City Municipality' },
    { value: '12', name: 'Butterworth' },
    { value: '13', name: 'Centane' },
    { value: '14', name: 'Chris Hani' },
    { value: '15', name: 'Chris Hani DM' },
    { value: '16', name: 'Cofimvaba' },
    { value: '17', name: 'Dawid Stuurman' },
    { value: '18', name: 'Dimbaza' },
    { value: '19', name: 'East London/Duncan Village' },
    { value: '20', name: 'EC Midlands' },
    { value: '21', name: 'Emalahleni' },
    { value: '22', name: 'Engcobo' },
    { value: '23', name: 'Engcobo LM' },
    { value: '24', name: 'Enoch Mgijima' },
    { value: '25', name: 'Enoch Mgijima LM' },
    { value: '26', name: 'Florence Matomela Bld' },
    { value: '27', name: 'Gqeberha' },
    { value: '28', name: 'Graaff Reinet' },
    { value: '29', name: 'Great Kei' },
    { value: '30', name: 'Intsika Yethu' },
    { value: '31', name: 'Inxuba Yethemba LM' },
    { value: '32', name: 'Joe Gqabi' },
    { value: '33', name: 'Joe Gqabi DM' },
    { value: '34', name: 'Klipplaat' },
    { value: '35', name: 'KwaZakhele' },
    { value: '36', name: 'Lukhanji' },
    { value: '37', name: 'Lusikisiki' },
    { value: '38', name: 'Maclear' },
    { value: '39', name: 'Mbizana' },
    { value: '40', name: 'Mdantsane' },
    { value: '41', name: 'Motherwell' },
    { value: '42', name: 'Mt Fletcher' },
    { value: '43', name: 'Mt Frere' },
    { value: '44', name: 'Ngqamakhwe' },
    { value: '45', name: 'Ngqurha' },
    { value: '46', name: 'NMBM' },
    { value: '47', name: 'OR Tambo' },
    { value: '48', name: 'OR Tambo DM' },
    { value: '49', name: 'PE Nothern Areas' },
    { value: '50', name: 'PE South West' },
    { value: '51', name: 'Port Alfred' },
    { value: '52', name: 'Port St Johns' },
    { value: '53', name: 'Qumbu' },
    { value: '54', name: 'Regional Office Chris Hani (Queenstown)' },
    { value: '55', name: 'Sakhisizwe' },
    { value: '56', name: 'Seymour' },
    { value: '57', name: 'Sterkspruit' },
    { value: '58', name: 'Stutterheim' },
    { value: '59', name: 'Sundays River Valley LM' },
    { value: '60', name: 'Tsomo' },
    { value: '61', name: 'Uitenhage' },
    { value: '62', name: 'Walmer' },
    { value: '63', name: 'Whittlesea' },
    { value: '64', name: 'Willowvale' },
    { value: '65', name: 'Winterhoek' },
    { value: '66', name: 'Zuurberg' },
    { value: '67', name: 'Ntsikana' },
    { value: '68', name: 'Raymond Mhlaba LM' },
    { value: '69', name: 'Tsolo' },
];
export default constituencies;